module.exports = __webpack_public_path__ + "static/img/AD.b7362367.png";